import React, { useState } from 'react';
import ReactModal from 'react-modal';

import TModalBase from './@types/TModalBase';

import getClassNames from '../../utils/className/getClassNames';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';
import getScrollbarWidth from '../../utils/getScrollbarWidth';

const ModalBase = ({
  kind,
  size = 's',
  children,
  className,
  onClose,
  pageBodyElement,
  ariaLabel,
  ...rest
}: TModalBase) => {
  const pageBodySelector = pageBodyElement || '.mp-Page-body';
  const hasPageBodyElement = Boolean(document.querySelector(pageBodySelector));
  const overlayClassName = getClassNames({ name: 'Overlay' });
  const modalModifiers = filterConditionalKeyValues({
    modifiers: [kind, size],
  });
  const modalClassName = getClassNames({
    name: 'Modal',
    ...modalModifiers,
    custom: className,
  });

  if (hasPageBodyElement) {
    ReactModal.setAppElement(pageBodySelector);
  }

  const onAfterClose = () => {
    document.body.style.paddingRight = '0';
  };

  /**
   * We need to fix content shifting when modal is open because of hiding/showing of the scrollbar
   */
  const [hasUpdatedBodyPadding, setHasUpdatedBodyPadding] = useState(false);
  if (!hasUpdatedBodyPadding) {
    document.body.style.paddingRight = `${getScrollbarWidth()}px`;
    setHasUpdatedBodyPadding(true);
  }

  return (
    <ReactModal
      isOpen={hasUpdatedBodyPadding}
      className={modalClassName}
      overlayClassName={overlayClassName}
      ariaHideApp={hasPageBodyElement}
      contentLabel={ariaLabel}
      onRequestClose={onClose}
      onAfterClose={onAfterClose}
      {...rest}
    >
      {children}
    </ReactModal>
  );
};

export default ModalBase;
